import { createSlice } from "@reduxjs/toolkit";
import { BeneficiariesInitialLoad, BeneficiariesPagination } from "../thunk/BeneficiariesThunk";



const initialState = {
    beneficiaries: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};


export const BeneficiariesSlice = createSlice({
    name: "beneficiaries",
    initialState,
    reducers: {
        resetBeneficiaries: (state, action) => {
            return {
                ...initialState
            };

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(BeneficiariesInitialLoad.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(BeneficiariesInitialLoad.fulfilled, (state, action) => {
                return {
                    ...state,
                    beneficiaries: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(BeneficiariesInitialLoad.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            })
            .addCase(BeneficiariesPagination.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(BeneficiariesPagination.fulfilled, (state, action) => {
                return {
                    ...state,
                    beneficiaries: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(BeneficiariesPagination.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }
                return { ...state, errorMessage, showLoading: false }
            });
    },
});


export const { resetBeneficiaries } = BeneficiariesSlice.actions;

export const BeneficiariesReducer = BeneficiariesSlice.reducer;